import React, { useState, useEffect } from 'react';
import './Step4Outputs.css';
import { apiService } from '../../../../services/api';

const Step4Outputs = ({ formData, onSetFormData }) => {
  const [datasets, setDatasets] = useState([]);
  const [loading, setLoading] = useState(false);
  const [datasetAction, setDatasetAction] = useState('create'); // 'create' or 'update'
  const createPerFileDataset = !!formData.createPerFileDataset;

  useEffect(() => {
    if (datasetAction === 'update') {
      const fetchDatasets = async () => {
        try {
          setLoading(true);
          const response = await apiService.getDatasets({ page_size: 100 });
          setDatasets(response.items || []);
        } catch (error) {
          console.error('Error fetching datasets:', error);
          setDatasets([]);
        } finally {
          setLoading(false);
        }
      };
      fetchDatasets();
    }
  }, [datasetAction]);

  const handleActionChange = (action) => {
    setDatasetAction(action);
    onSetFormData({
      ...formData,
      datasetAction: action,
      datasetId: action === 'create' ? null : formData.datasetId,
      datasetName: action === 'create' ? '' : formData.datasetName,
      // Per-file mode is only meaningful under 'create' action; clear it on switch.
      createPerFileDataset: action === 'create' ? !!formData.createPerFileDataset : false
    });
  };

  const handlePerFileToggle = (checked) => {
    onSetFormData({
      ...formData,
      createPerFileDataset: checked,
      // Wipe the single dataset name when per-file mode is on; the runner names
      // each dataset after the file.
      datasetName: checked ? '' : formData.datasetName
    });
  };

  const handleDatasetSelect = (datasetId) => {
    const selected = datasets.find(d => d.id === datasetId);
    onSetFormData({
      ...formData,
      datasetId: datasetId,
      datasetName: selected ? selected.name : ''
    });
  };

  return (
    <div className="step-content">
      <h3 className="step-title">Outputs</h3>
      <p className="step-subtitle">Define what this automation does with the data.</p>

      <div className="form-field">
        <label>Target Dataset</label>
        <div className="radio-group">
          <label className="resui-radio">
            <input
              type="radio"
              className="resui-radio-input"
              name="datasetAction"
              value="create"
              checked={datasetAction === 'create'}
              onChange={() => handleActionChange('create')}
            />
            <span className="resui-radio-mark" />
            <span className="resui-radio-label">Create new dataset</span>
          </label>
          <label className="resui-radio">
            <input
              type="radio"
              className="resui-radio-input"
              name="datasetAction"
              value="update"
              checked={datasetAction === 'update'}
              onChange={() => handleActionChange('update')}
            />
            <span className="resui-radio-mark" />
            <span className="resui-radio-label">Update existing dataset</span>
          </label>
        </div>
      </div>

      {datasetAction === 'create' && (
        <>
          <div className="form-field">
            <label className="step-create-group-label resui-checkbox">
              <input
                type="checkbox"
                className="step-create-group-checkbox resui-checkbox-input"
                checked={createPerFileDataset}
                onChange={(e) => handlePerFileToggle(e.target.checked)}
              />
              <span className="resui-checkbox-mark" />
              <span className="resui-checkbox-label">Create one dataset per file (named after the filename)</span>
            </label>
            <p className="form-helper-text">
              When enabled, each file fetched by this automation becomes its own dataset. Leave unchecked
              to group all files into a single dataset.
            </p>
          </div>

          {!createPerFileDataset && (
            <>
              <div className="form-field">
                <label>Dataset name</label>
                <input
                  className="resui-input"
                  type="text"
                  placeholder="e.g., RCN - Inspections (raw)"
                  value={formData.datasetName || ''}
                  onChange={(e) => onSetFormData({ ...formData, datasetName: e.target.value })}
                />
              </div>
              <p className="form-helper-text">
                This dataset will appear under Data Sources and can be used by Ask ResAI and other automations.
              </p>
            </>
          )}
        </>
      )}

      {datasetAction === 'update' && (
        <div className="form-field">
          <label>Select dataset</label>
          {loading ? (
            <p>Loading datasets...</p>
          ) : (
            <select
              className="resui-select"
              value={formData.datasetId || ''}
              onChange={(e) => handleDatasetSelect(e.target.value)}
            >
              <option value="">Select a dataset</option>
              {datasets.map((dataset) => (
                <option key={dataset.id} value={dataset.id}>
                  {dataset.name}
                </option>
              ))}
            </select>
          )}
        </div>
      )}
    </div>
  );
};

export default Step4Outputs;


